import { apiV1 } from './api';

const getCategories = () => apiV1.get('/users/categories');

export { getCategories };
